import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Stack,
} from "@mui/material";
import React from "react";
import { InnerWrapper } from "../wrapper/wrapper";
import { community, company, more, SocialIcons } from "./contents";
import { Link } from "react-router-dom";
import {
  AboutCompany,
  CompanyName,
  CopyrightText,
  HrLine,
  ListText,
  MainContainer,
  Title,
} from "./footer.components";
import ArrowIcon from "../../images/icons/arrow.svg";

function Footer() {
  return (
    <MainContainer>
      <InnerWrapper sx={{ pb: 7 }}>
        <Grid container columns={16} sx={{ pt: 8 }}>
          <Grid item xs={1} />
          <Grid item xs={14} md={6}>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2.5}
            >
              <CompanyName>XPVERSE</CompanyName>
              <AboutCompany sx={{ width: { md: 240 } }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor
                sit amet, consectetur adipiscing elit
              </AboutCompany>
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1.5}
              >
                {SocialIcons.map((social) => {
                  return (
                    <IconButton component={Link} to={social.url} sx={{ p: 0 }}>
                      <Box component="img" src={social.icon} alt="" />
                    </IconButton>
                  );
                })}
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={14} md={8} sx={{ pt: { xs: 5, md: 0 } }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={{ xs: 3, sm: 9 }}
              pl={{ xs: 3.5, sm: 6.25, md: 0 }}
            >
              <Content data={company} />
              <Content data={community} />
              <Content data={more} />
            </Stack>
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </InnerWrapper>
      <HrLine />
      <InnerWrapper sx={{ py: 2.6 }}>
        <CopyrightText sx={{ fontSize: { xs: "13px", md: "15px" } }}>
          ©2022 Xpverse Private Limited. All Rights Reserved.
        </CopyrightText>
      </InnerWrapper>
    </MainContainer>
  );

  function Content({ data }) {
    return (
      <Box sx={{ width: "100%" }}>
        <Title>{data.title}</Title>
        <List>
          {data.items.map((item) => {
            return (
              <ListItem
                component={Link}
                to={item.url}
                sx={{ py: 0.3, px: 0.75 }}
              >
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <Box component="img" src={ArrowIcon} />
                </ListItemIcon>
                <ListText primary={item.text} />
              </ListItem>
            );
          })}
        </List>
      </Box>
    );
  }
}

export default Footer;
